// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__8mbkD","header":"PatientQuestionnaire_header__3B6pt","info":"PatientQuestionnaire_info__3ff6W"};